import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { TipoCondicionDTO } from "../../interfaces/tipo-condicion.interface";
import { environment as ENV } from "environments/environment";
import { RegionComunaDTO } from "../../interfaces/region-comuna.interface";
import { TipoDTO } from "../../interfaces/tipo.interface";
import { CodigoDTO } from "../../interfaces/codigo.interface";
import { tap } from "rxjs/operators";
import { UF } from "../../interfaces/uf.interface";
const API = "codigos/";

@Injectable({
    providedIn: "root",
})
export class CodigosService {
    comunasChanged$: Subject<RegionComunaDTO[]>;
    recargarComunasChange$: Subject<boolean>

    private condiciones: TipoCondicionDTO[];
    private bancos: CodigoDTO[];
    private tiposCuenta: TipoDTO[];
    private regiones: RegionComunaDTO[];
    private comunas: CodigoDTO[];
    private uf: UF;
    constructor(private http: HttpClient) {
        this.comunasChanged$ = new Subject();
        this.recargarComunasChange$=new Subject();
    }

    fetchCondicionesServicio(): Observable<TipoCondicionDTO[]> {
        if (!this.condiciones) {
            return this.http
                .get<TipoCondicionDTO[]>(`${ENV.apiUrl}${API}condiciones`)
                .pipe(tap((condiciones) => this.setCondiciones(condiciones)));
        } else {
            return of(this.condiciones);
        }
    }

    setCondiciones(condiciones: TipoCondicionDTO[]) {
        this.condiciones = condiciones;
    }

    fetchRegiones(): Observable<RegionComunaDTO[]> {
        if (!this.regiones) {
            return this.http
                .get<RegionComunaDTO[]>(`${ENV.apiUrl}${API}regiones`)
                .pipe(tap((regiones) => this.setRegiones(regiones)));
        } else {
            return of(this.regiones);
        }
    }

    setRegiones(regiones: RegionComunaDTO[]) {
        this.regiones = regiones;
    }

    fetchComunasRegion(idRegion: number): Observable<RegionComunaDTO[]> {
        return this.http.get<RegionComunaDTO[]>(
            `${ENV.apiUrl}${API}${idRegion}/comunas`
        );
    }

    fetchBancos(): Observable<CodigoDTO[]> {
        if (!this.bancos) {
            return this.http
                .get<CodigoDTO[]>(`${ENV.apiUrl}${API}bancos`)
                .pipe(tap((bancos) => this.setBancos(bancos)));
        } else {
            return of(this.bancos);
        }
    }

    fetchTiposCuenta(): Observable<TipoDTO[]> {
        if (!this.tiposCuenta) {
            return this.http
                .get<TipoDTO[]>(`${ENV.apiUrl}${API}tiposCuenta`)
                .pipe(
                    tap((tiposCuentasBancarias) =>
                        this.setTiposBanco(tiposCuentasBancarias)
                    )
                );
        } else {
            return of(this.tiposCuenta);
        }
    }

    setBancos(bancos: CodigoDTO[]) {
        this.bancos = bancos;
    }
    setTiposBanco(tiposCuenta: TipoDTO[]) {
        this.tiposCuenta = tiposCuenta;
    }

    fetchComunas(): Observable<CodigoDTO[]> {
        if (!this.comunas) {
            return this.http
                .get<CodigoDTO[]>(`${ENV.apiUrl}${API}comunas`)
                .pipe(tap((comunas) => this.setComunas(comunas)));
        } else {
            return of(this.comunas);
        }
    }

    setComunas(comunas: CodigoDTO[]) {
        this.comunas = comunas;
    }

    saveRecargoComuna(comuna: RegionComunaDTO): Observable<any> {
        return this.http.patch(
            `${ENV.apiUrl}${API}comunas/${comuna.id}?recargo=${comuna.recargo}`,
            null
        );
    }

    fetchUnidadesTiempo(): Observable<TipoDTO[]> {
        return this.http.get<TipoDTO[]>(`${ENV.apiUrl}${API}unidadesTiempo`);
    }

    fetchUnidadesMedida(): Observable<TipoDTO[]> {
        return this.http.get<TipoDTO[]>(`${ENV.apiUrl}${API}unidadesMedida`);
    }

    fetchTiposDocumentos(): Observable<TipoDTO[]> {
        return this.http.get<TipoDTO[]>(`${ENV.apiUrl}${API}tiposDocumento`);
    }

    setUf(uf: UF) {
        this.uf = uf;
    }
    fetchUF(fecha: string = ""): Observable<UF> {
        if (!this.uf) {
            return this.http
                .get<UF>(`${ENV.apiUrl}${API}uf?fecha=${fecha}`)
                .pipe(tap((uf) => this.setUf(uf)));
        } else {
            return of(this.uf);
        }
    }
}
